import React, { FC, useMemo } from 'react';
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { USD_MILLIONS, USD_THOUSANDS } from 'components/FeaturedSpreadsheet/constants';
import { IndicatorProps } from './Indicator.props';
import {
  StyledArrow,
  StyledContainer,
  StyledMainValue,
  StyledMainValueContainer,
  StyledPercentage,
  StyledPercentageContainer,
  StyledTitle,
  StyledUnitBadge,
  StyledValueContainer,
} from './Indicator.styles';

export const Indicator: FC<IndicatorProps> = ({ title, value, percentage, unit, className }) => {
  const { color, ArrowIcon } = useMemo(() => {
    if (percentage === undefined || percentage === null) {
      return { color: '#65C687', ArrowIcon: ArrowUpward };
    }
    const isPositive = percentage > 0;
    return {
      color: isPositive ? '#65C687' : '#FF6B6B',
      ArrowIcon: isPositive ? ArrowUpward : ArrowDownward,
    };
  }, [percentage]);

  const displayPercentage =
    percentage !== undefined && percentage !== null ? `${Math.abs(percentage).toFixed(1)}%` : null;

  const unitBadgeText = useMemo(() => {
    if (unit === USD_THOUSANDS) {
      return 'Thousands';
    }
    if (unit === USD_MILLIONS) {
      return 'Millions';
    }
    return null;
  }, [unit]);

  return (
    <StyledContainer className={className}>
      {title && <StyledTitle variant="h6">{title}</StyledTitle>}
      {((value !== undefined && value !== null) || (percentage !== undefined && percentage !== null)) && (
        <StyledValueContainer>
          {value !== undefined && value !== null && (
            <StyledMainValueContainer>
              <StyledMainValue>{typeof value === 'string' ? value : value.toFixed(1)}</StyledMainValue>
              {unitBadgeText && <StyledUnitBadge>{unitBadgeText}</StyledUnitBadge>}
            </StyledMainValueContainer>
          )}
          {percentage !== undefined && percentage !== null && displayPercentage && (
            <StyledPercentageContainer>
              <StyledArrow color={color}>
                <ArrowIcon />
              </StyledArrow>
              <StyledPercentage color={color}>{displayPercentage}</StyledPercentage>
            </StyledPercentageContainer>
          )}
        </StyledValueContainer>
      )}
    </StyledContainer>
  );
};

export default Indicator;
